/* kone-pdp (Vaistoa, 16.10.2026): ponnahdukset + kokotaulukko. Vain näyttö: varianttien arvot ja id:t eivät muutu. */
(() => {
  'use strict';
  const luku = s => (s.match(/\d+(?:[.,]\d+)?/g) || []).map(v => Number(v.replace(',', '.')));
  function lueRivit(d) { // kokotaulukkosivun taulukko → [{eu, uk, jalka, sisa}] tai null
    const alkup = d.querySelector('[data-kp-alkup]'); if (!alkup) return null;
    const taulu = [...alkup.querySelectorAll('table')].find(t => /foot length|fotlängd|fotens längd/i.test(t.tHead?.textContent || '') && t.tBodies[0]?.rows.length);
    if (!taulu) return null;
    const rivit = [];
    for (const tr of taulu.tBodies[0].rows) {
      const c = [...tr.cells]; if (c.length < 3) return null;
      const kopio = c[1].cloneNode(true); kopio.querySelectorAll('.vk-uk').forEach(x => x.remove());
      rivit.push({ eu: kopio.textContent.trim(), uk: (c[1].querySelector('.vk-uk')?.textContent || '').replace(/^\s*UK\s*/i, '').trim(), jalka: luku(c[0].textContent), sisa: luku(c[2].textContent) });
    }
    return rivit;
  }
  function kokotaulukko(d) {
    const alkup = d.querySelector('[data-kp-alkup]');
    const taulu = [...alkup.querySelectorAll('table')].find(t => /foot length|fotlängd|fotens längd/i.test(t.tHead?.textContent || '') && t.tBodies[0]?.rows.length);
    if (!taulu) return; // lukeminen ei onnistu → alkuperäinen sivu näkyy sellaisenaan
    const rivit = [];
    for (const tr of taulu.tBodies[0].rows) {
      const c = [...tr.cells]; if (c.length < 3) return;
      const kopio = c[1].cloneNode(true); kopio.querySelectorAll('.vk-uk').forEach(x => x.remove());
      const eu = kopio.textContent.trim();
      const uk = (c[1].querySelector('.vk-uk')?.textContent || '').replace(/^\s*UK\s*/i, '').trim();
      const jalka = luku(c[0].textContent), sisa = luku(c[2].textContent);
      if (!eu || jalka.length !== 2 || sisa.length !== 2) return;
      rivit.push({ eu, uk, jalka, sisa });
    }
    if (!rivit.length) return;
    // UK piilossa (Johtaja 16.10. 13.52): sivujen UK-arvot osin virheellisiä, ei arvata. Kun korjattu valmistajan taulukosta: ukOk = rivit.some(r => r.uk).
    const UK_NAKYY = true; // Johtaja 18.08: Henryn 16.9. lukitsema vastaavuus, samat arvot jo livessä kokotaulukoissa
    const ukOk = UK_NAKYY && rivit.some(r => r.uk);
    let jarj = 'eu', yks = 'cm';
    const n = v => { if (yks === 'in') return (v / 2.54).toFixed(2); const s = v.toFixed(2); return s.endsWith('0') ? v.toFixed(1) : s; };
    const tb = d.querySelector('[data-kp-taulukko] tbody');
    function piirra() {
      tb.replaceChildren(...rivit.map(r => {
        const tr = document.createElement('tr');
        [`${n(r.jalka[0])}–${n(r.jalka[1])}`, jarj === 'uk' ? (r.uk || '–') : r.eu, n(r.sisa[0]), n(r.sisa[1])].forEach((v, i) => {
          const e = document.createElement(i === 0 ? 'th' : 'td'); if (i === 0) e.scope = 'row'; e.textContent = v; tr.append(e);
        });
        return tr;
      }));
      d.querySelectorAll('[data-kp-jarj]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.kpJarj === jarj)));
      d.querySelectorAll('[data-kp-yks]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.kpYks === yks)));
      d.querySelectorAll('[data-kp-yks-teksti]').forEach(e => e.textContent = yks === 'in' ? '(in)' : '(cm)');
      d.querySelectorAll('[data-kp-jarj-teksti]').forEach(e => e.textContent = jarj === 'uk' ? '(UK)' : '(EU)');
    }
    if (!ukOk) d.querySelector('[data-kp-jarj]').parentElement.hidden = true; // ei UK-kokoja → ei järjestelmävalintaa
    d.querySelectorAll('[data-kp-jarj]').forEach(b => { b.addEventListener('click', () => { jarj = b.dataset.kpJarj; piirra(); }); });
    d.querySelectorAll('[data-kp-yks]').forEach(b => b.addEventListener('click', () => { yks = b.dataset.kpYks; piirra(); }));
    piirra();
    d.querySelector('[data-kp-valinnat]').hidden = false;
    d.querySelector('[data-kp-taulukko]').hidden = false;
    d.querySelector('[data-kp-huomio]').hidden = false;
    alkup.hidden = true;
    // 22.10. (Henry 13.17): mittojen päivä taulukon alle sivun omasta "*Päivitetty/Updated/Uppdaterad <pvm>" -rivistä; ei löydy tai useita eri päiviä → ei näytetä
    const pv = d.querySelector('[data-kp-paivitetty]');
    const pvt = [...new Set([...alkup.textContent.replace(/\s+/g, ' ').matchAll(/(?:Päivitetty|Updated|Uppdaterad)\s*:?\s*(\d{1,2}\.\d{1,2}\.\d{4})/gi)].map(m => m[1]))];
    if (pv && pvt.length === 1) { pv.textContent = `${pv.dataset.teksti} ${pvt[0]}`; pv.hidden = false; }
  }
  function init(juuri) {
    if (juuri.dataset.kpValmis) return; juuri.dataset.kpValmis = '1';
    const napit = [...juuri.querySelectorAll('[data-kp-avaa]')]; // talteen ennen kuin linkki siirretään kokoriville
    if (juuri.classList.contains('kone-pdp--koko')) { // Size guide -linkki kokorivin otsikon viereen, apurivi kokonappien alle (Mikon esikatselun malli)
      const ryhmat = [...(juuri.closest('.product-section') || document).querySelectorAll('fieldset.variant-input-wrap')];
      const koot = ryhmat.find(g => { const i = [...g.querySelectorAll('input')]; return i.length && i.every(x => /^\d+(?:[.,]\d+)?$/.test(x.value)); });
      const otsikko = koot && koot.parentElement.querySelector('.variant__label');
      const linkki = juuri.querySelector('[data-kp-kokolinkki]'); const vihje = juuri.querySelector('[data-kp-vihje]');
      if (otsikko && linkki) {
        const rivi = document.createElement('div'); rivi.className = 'kone-pdp__kokorivi';
        otsikko.classList.add('kone-pdp__piilo'); // SIZE-otsikko pois näkyvistä, jää ruudunlukijalle (Henry 17.40)
        // Mikon esikatselun rakenne (Henry 17.59): "Size: EU 36" + Size guide -painike → EU/UK/US-kytkin → kokosuositus → 6 sarakkeen ruudukko
        const kOts = juuri.querySelector('[data-kp-koko-otsikko]'); const jarj = juuri.querySelector('[data-kp-jarjestelma]');
        // Henry 18.28 (#20): EU/UK-kytkin vasemmalle ja Size guide samalle riville oikealle
        otsikko.after(rivi); if (kOts) rivi.append(kOts); if (jarj) rivi.append(jarj); rivi.append(linkki);
        if (vihje) { rivi.after(vihje); }
        koot.classList.add('kone-pdp__koot');
        const valittu = kOts && kOts.querySelector('[data-kp-valittu]');
        const paivita = () => { const v = koot.querySelector('input:checked'); if (valittu) valittu.textContent = v ? v.value : ''; };
        koot.addEventListener('change', paivita); paivita();
        // EU/UK-kytkin kokonappeihin (Mikon malli): vain näkyvä teksti vaihtuu, option arvot ja variantit ennallaan
        const dlg = linkki && document.getElementById(linkki.dataset.kpAvaa);
        const rivit = dlg ? lueRivit(dlg) : null;
        const ukNappi = jarj && jarj.querySelector('[data-kp-koko-jarj="uk"]');
        const syotteet = [...koot.querySelectorAll('input')];
        const uk = rivit ? Object.fromEntries(rivit.filter(r => r.uk).map(r => [r.eu, r.uk])) : {};
        if (ukNappi && syotteet.length && syotteet.every(i => uk[i.value])) {
          ukNappi.disabled = false; ukNappi.removeAttribute('title');
          const nimi = kOts && kOts.querySelector('[data-kp-jarj-nimi]');
          const aseta = (j) => {
            jarj.querySelectorAll('[data-kp-koko-jarj]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.kpKokoJarj === j)));
            syotteet.forEach(i => { const l = koot.querySelector(`label[for="${CSS.escape(i.id)}"]`); if (l) { l.textContent = j === 'uk' ? uk[i.value] : i.value; l.setAttribute('aria-label', (j === 'uk' ? 'UK ' : 'EU ') + l.textContent); } });
            if (nimi) nimi.textContent = j.toUpperCase();
            if (valittu) { const v = koot.querySelector('input:checked'); valittu.textContent = v ? (j === 'uk' ? uk[v.value] : v.value) : ''; }
            const dj = dlg && dlg.querySelector(`[data-kp-jarj="${j}"]`); if (dj && !dj.hidden) dj.click();
            jarj.dataset.valittu = j;
          };
          jarj.querySelectorAll('[data-kp-koko-jarj]').forEach(b => b.addEventListener('click', () => { if (!b.disabled) aseta(b.dataset.kpKokoJarj); }));
          koot.addEventListener('change', () => { if (jarj.dataset.valittu === 'uk') aseta('uk'); });
        }
      }
    }
    if (juuri.classList.contains('kone-pdp--turva')) { // suoraan ostonapin alle, ennen maksukuvakkeita (päätös 2)
      const nappi = juuri.closest('.product-section')?.querySelector('button[name="add"]');
      let kohta = nappi; while (kohta && kohta.parentElement && kohta.parentElement.tagName !== 'FORM') kohta = kohta.parentElement;
      if (kohta && kohta.parentElement) kohta.after(juuri);
    }
    napit.forEach(nappi => {
      const d = document.getElementById(nappi.dataset.kpAvaa); if (!d) return;
      if (d.parentElement !== document.body) document.body.appendChild(d); // irti tuotelohkon pinoamisesta
      nappi.addEventListener('click', () => { d.showModal(); document.documentElement.classList.add('kone-pdp-auki'); });
      d.querySelectorAll('[data-kp-sulje]').forEach(b => b.addEventListener('click', () => d.close()));
      d.addEventListener('click', e => { if (e.target !== d) return; const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); });
      d.addEventListener('close', () => { document.documentElement.classList.remove('kone-pdp-auki'); nappi.focus(); });
      if (d.querySelector('[data-kp-alkup]')) kokotaulukko(d);
    });
  }
  const tyhjat = () => document.querySelectorAll('.product-section [data-product-blocks] > .product-block, .kone-pdp__info > .product-block').forEach(b => {
    if (!b.children.length && !b.textContent.trim()) b.classList.add('kone-pdp-tyhja'); // tyhjä lohko = turha väli mobiilissa
  });
  // Usizy-esikatselumerkintä poistettu 21.10.2026 (Henry #22: "riittää What is my size?").
  const aja = () => { const k = document.querySelectorAll('[data-kone-pdp]'); k.forEach(init); if (k.length) tyhjat(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aja); else aja();
  document.addEventListener('shopify:section:load', aja);
})();
